import { useEffect } from 'react'
import { useMap } from '@wehunt/map'
import { NO_PRINT_INSETS, type PrintInsets } from './usePrintInsets'

export function PrintMapPadding({ padding }: { padding: PrintInsets }) {
  const map = useMap()
  useEffect(() => {
    map?.setPadding(padding)
    return () => {
      map?.setPadding(NO_PRINT_INSETS)
    }
  }, [map, padding])
  return null
}
